<script lang="ts">
import DepositWelcomeModal from '@/components/modals/DepositWelcomeModal.vue'
import { usePromotions } from '@/composables/usePromotions'
import { ThemeType } from '@goodlifeplus/themes'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    DepositWelcomeModal,
  },
  setup() {
    const { loadPromotions, showWelcomeBanner, promotionProgress } =
      usePromotions()

    return {
      loadPromotions,
      showWelcomeBanner,
      promotionProgress,
      ThemeType,
    }
  },
  mounted() {
    void this.loadPromotions()
  },
})
</script>

<template v-if="showWelcomeBanner">
  <DepositWelcomeModal :welcome-only="true">
    <template #button="{ openModal, hasAnyDepositOptions }">
      <button
        type="button"
        class="deposit-banner mask-squiggle before:min-w-[525px] before:left-[-110px]"
        :disabled="!hasAnyDepositOptions"
        :aria-disabled="!hasAnyDepositOptions"
        :style="{
          '--mask-squiggle-url': `url('/assets/images/masks/squiggle-lg.svg')`,
          '--mask-background':
            $theme.type === ThemeType.Club
              ? 'var(--mask-background)'
              : 'var(--gradient-purple)',
        }"
        @click="openModal()"
      >
        <div class="deposit-banner__content">
          <div class="deposit-banner__badge">
            <AppBadge
              size="md"
              class="text-pure-white bg-primary !p-2 uppercase leading-none !rounded-md"
            >
              Welcome Bonus
            </AppBadge>
          </div>

          <h1 class="deposit-banner__text">
            <span class="font-black"> Double Up Your Money </span>
            <br />
          </h1>
          <p class="deposit-banner__subtext text-left text-xs">
            We'll match your first deposit!
          </p>
          <AppButton
            title="Claim Bonus"
            class="button-primary deposit-banner__cta"
            :disabled="!hasAnyDepositOptions"
          >
            Claim Bonus
          </AppButton>
        </div>

        <div class="deposit-banner__image ml-auto">
          <img
            src="@/assets/images/banners/deposit.webp"
            alt="Deposit Banner Image"
            class="object-cover object-right h-full w-full max-w-[200px]"
          />

          <div class="deposit-banner__trustpilot">
            <AppTrustpilot size="sm" />
          </div>
        </div>
      </button>
    </template>
  </DepositWelcomeModal>
</template>

<style lang="scss" scoped>
.deposit-banner {
  @apply bg-center bg-cover overflow-hidden flex size-full border-none @container hover:cursor-pointer !h-[var(--header-banner-height)] @sm/main:rounded-lg text-pure-white relative bg-no-repeat bg-[url('@/assets/images/banners/texture-blue.webp')];

  .deposit-banner__content {
    @apply flex flex-col justify-between h-full z-[1] p-4 pb-3 w-fit gap-1;
  }

  .deposit-banner__text {
    @apply font-black text-2xl leading-7 text-left mb-3 mt-2;
  }

  .deposit-banner__subtext {
    @apply font-black;
  }

  .deposit-banner__image {
    @apply relative overflow-hidden h-[101%] flex items-end justify-end;
    min-width: 188px;
    max-width: 200px;
  }

  &:deep(.deposit-banner__cta) {
    @apply h-auto py-2 px-4 max-w-[var(--header-banner-static-section-width)] whitespace-nowrap leading-none capitalize font-bold border-none text-sm mt-auto !important;
  }

  .deposit-banner__trustpilot {
    @apply absolute bottom-2 left-1/2 -translate-x-1/2 justify-center items-center !w-full;

    .trustpilot-widget {
      @apply mx-2 bg-black rounded p-2 w-auto;

      @container (max-width: 359px) {
        .text-md {
          font-size: 0.625rem !important;
        }

        .text-xs {
          font-size: 0.625rem !important;
        }
      }
    }
  }
}
</style>
